import { Preferences } from "@capacitor/preferences";

export const setUser = async (user) => {
  await Preferences.set({
    key: "user",
    value: JSON.stringify(user),
  });
};

export const getUser = () => {
  return Preferences.get({ key: "user" }).then(({ value }) => {
    return value ? JSON.parse(value) : null;
  });
};

export const removeCookie = async (key) => {
  await Preferences.remove({ key: key });
};


// import Cookies from "js-cookie";

// export const setUser = (user) => {
//   setCookie("user", user, 1, true);
// };

// const setCookie = (key, value, expiresInDays, isJson = false) => {
//   if (isJson) {
//     value = JSON.stringify(value);
//   }
//   Cookies.set(key, value, { expires: expiresInDays, sameSite: "Strict" });
// };

// export const removeCookie = (key) => {
//   Cookies.remove(key);
// };

// export const getUser = () => {
//   return getCookie("user", true);
// };


// export const getCookie = (key, isJson) => {
//   let value = Cookies.get(key);
//   if (isJson && value) {
//     return JSON.parse(value);
//   }
//   return value;
// };

export const getUniqueDataById = (prevData, newData, idKey = "id") => {
  const combinedData = [...prevData, ...newData];
  const uniqueDataMap = new Map();

  combinedData.forEach((item) => {
    uniqueDataMap.set(item[idKey], item);
  });

  return Array.from(uniqueDataMap.values());
};

export const getFormattedAmount = (amount, digits = 2) => {
  amount = parseFloat(amount);
  return amount.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: digits
  });
};

export const getMonthStartEndDates = () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return { firstDay, lastDay };
};

export const getFormattedDate = (inputDate) => {
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDateDDMMYYYY = (dateStr) => {
  if (!dateStr) return "";
  return dateStr.split("-").reverse().join("-");
};

export const toProperCase = (str) => {
  if (!str) return "N/A";
  return str
    .toLowerCase()
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const displayValue = (value) =>
    value && value !== "" ? (
      value
    ) : (
      <span className="italic text-gray-400">Not Provided</span>
    );
export const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    }).format(amount);
  };

export const formatMonthYear = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleString("en-US", { month: "long", year: "numeric" });
};

export const formatAmount = (amount) => {
    if (amount === null || amount === undefined) return "";
    return Number(amount).toLocaleString("en-IN"); // adds commas for thousands
  };

